import { gql } from '@apollo/client';

export const CREATE_INVOICE = gql`
  mutation createInvoice(
    $clientId: Int!
    $userId: Int!
    $companyId: Int!
    $createInvoiceTaxesInput: [CreateInvoiceTaxInput!]!
    $createInvoiceInput: CreateInvoiceInput!
  ) {
    createInvoice(
      clientId: $clientId
      userId: $userId
      companyId: $companyId
      createInvoiceTaxesInput: $createInvoiceTaxesInput
      createInvoiceInput: $createInvoiceInput
    ) {
      id
      product
      date
      crt
      invoiceNumber
      invoiceValue
      invoiceQuantity
      unitCostReal
      realValue
      status
      totalCost
      unitCostTotal
      unitSale
      unitProfit
      totalProfit
      labeled
      observation
      invoiceTaxes {
        id
        value
        tax {
          id
          value
          name
          description
          createdAt
          updatedAt
        }
      }
      company {
        id
        name
      }
      clientId
      companyId
      group {
        id
        number
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const FILTER_INVOICE_PRODUCT = gql`
  query filterInvoiceProduct($clientId: Int!, $searchQuery: String!) {
    filterInvoiceProduct(clientId: $clientId, searchQuery: $searchQuery) {
      code
      resume
    }
  }
`;

export const INVOICE_DASHBOARD = gql`
  query invoiceDashboard($groupId: Int) {
    invoiceDashboard(groupId: $groupId) {
      data {
        invoiceValue
        realValue
        totalCost
        totalProfit
        timestamp
      }
    }
  }
`;

export const DEPOSIT_DASHBOARD = gql`
  query depositDashboard($groupId: Int) {
    depositDashboard(groupId: $groupId) {
      data {
        value
        timestamp
      }
    }
  }
`;

export const CREATE_TAX = gql`
  mutation createTax($clientId: Int!, $createTaxInput: CreateTaxInput!) {
    createTax(clientId: $clientId, createTaxInput: $createTaxInput) {
      id
      name
      value
      description
      clientId
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_COMPANY = gql`
  mutation createCompany(
    $clientId: Int!
    $createCompanyInput: CreateCompanyInput!
  ) {
    createCompany(
      clientId: $clientId
      createCompanyInput: $createCompanyInput
    ) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_DEPOSIT = gql`
  mutation createDeposit(
    $clientId: Int!
    $userId: Int!
    $createDepositInput: CreateDepositInput!
  ) {
    createDeposit(
      clientId: $clientId
      userId: $userId
      createDepositInput: $createDepositInput
    ) {
      id
      date
      reference
      value
      user {
        id
        email
        username
        name
      }
      company {
        id
        name
      }
      group {
        id
        number
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_LOGISTIC = gql`
  mutation createLogistic(
    $clientId: Int!
    $userId: Int!
    $createLogisticInput: CreateLogisticInput!
  ) {
    createLogistic(
      clientId: $clientId
      userId: $userId
      createLogisticInput: $createLogisticInput
    ) {
      id
      quantityVolume
      nrcInvoiceNumber
      clientInvoiceNumber
      crt
      clientName
      warehouseDispatchDate
      revenueDate
      customsDate
      storageDate
      clientDate
      releaseDate
      observation
      user {
        id
        email
        username
        name
      }
      company {
        id
        name
      }
      group {
        id
        number
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_LOGISTIC_ORIGIN = gql`
  mutation createLogisticOrigin(
    $clientId: Int!
    $userId: Int!
    $createLogisticOriginInput: CreateLogisticOriginInput!
  ) {
    createLogisticOrigin(
      clientId: $clientId
      userId: $userId
      createLogisticOriginInput: $createLogisticOriginInput
    ) {
      id
      originInvoiceNumber
      quantityVolume
      releaseDate
      user {
        id
        email
        username
        name
      }
      company {
        id
        name
      }
      group {
        id
        number
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_DEPOSITS = gql`
  mutation createDeposits(
    $clientId: Int!
    $userId: Int!
    $createDepositsInput: [CreateDepositInput!]!
  ) {
    createDeposits(
      clientId: $clientId
      userId: $userId
      createDepositsInput: $createDepositsInput
    ) {
      count
    }
  }
`;

export const FILTER_INVOICE = gql`
  query filterInvoice(
    $searchFilter: SearchFilter!
  ) {
    filterInvoice(
      searchFilter: $searchFilter
    ) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        product
        date
        crt
        invoiceNumber
        invoiceValue
        invoiceQuantity
        unitCostReal
        realValue
        status
        totalCost
        unitCostTotal
        unitSale
        unitProfit
        totalProfit
        labeled
        observation
        locked
        companyId
        clientId
        invoiceTaxes {
          id
          value
          tax {
            id
            value
            name
            description
            createdAt
            updatedAt
          }
        }
        company {
          id
          name
        }
        group {
          id
          number
          name
        }
        createdAt
        updatedAt
      }
      report {
        totalInvoiceValue
        totalRealValue
        totalTotalCost
        totalUnitSale
        totalTotalProfit
        totalTaxes {
          tax {
            id
            name
          }
          total
        }
      }
    }
  }
`;

export const FILTER_TAX = gql`
  query filterTax($searchFilter: SearchFilter!) {
    filterTax(searchFilter: $searchFilter) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        name
        value
        description
        clientId
        createdAt
        updatedAt
      }
    }
  }
`;

export const FILTER_COMPANY = gql`
  query filterCompany($searchFilter: SearchFilter!) {
    filterCompany(searchFilter: $searchFilter) {
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        name
        clientId
        createdAt
        updatedAt
      }
    }
  }
`;

export const FILTER_DEPOSIT = gql`
  query filterDeposit(
    $searchFilter: SearchFilter!
  ) {
    filterDeposit(
      searchFilter: $searchFilter
    ) {
      report {
        total
      }
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        date
        reference
        value
        locked
        company {
          id
          name
        }
        group {
          id
          number
          name
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const FILTER_DAILY_DEPOSIT = gql`
  query filterDailyDeposit(
    $searchFilter: SearchFilter!
  ) {
    filterDailyDeposit(
      searchFilter: $searchFilter
    ) {
      report {
        total
        quantity
      }
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        value
        reference
        quantity
      }
    }
  }
`;

export const FILTER_LOGISTIC = gql`
  query filterLogistic(
    $searchFilter: SearchFilter!
  ) {
    filterLogistic(
      searchFilter: $searchFilter
    ) {
      report {
        quantityVolume
      }
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        quantityVolume
        nrcInvoiceNumber
        clientInvoiceNumber
        crt
        clientName
        warehouseDispatchDate
        revenueDate
        customsDate
        storageDate
        clientDate
        releaseDate
        observation
        company {
          id
          name
        }
        group {
          id
          number
          name
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const FILTER_LOGISTIC_ORIGIN = gql`
  query filterLogisticOrigin(
    $searchFilter: SearchFilter!
  ) {
    filterLogisticOrigin(
      searchFilter: $searchFilter
    ) {
      report {
        quantityVolume
      }
      meta {
        total
        lastPage
        currentPage
        perPage
        prev
        next
      }
      data {
        id
        originInvoiceNumber
        quantityVolume
        releaseDate
        company {
          id
          name
        }
        group {
          id
          number
          name
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const AUTOCOMPLETE_INVOICE = gql`
  query autocompleteInvoice(
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteInvoice(
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const AUTOCOMPLETE_TAX = gql`
  query autocompleteTax(
    $clientId: Int!
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteTax(
      clientId: $clientId
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const AUTOCOMPLETE_LOGISTIC = gql`
  query autocompleteLogistic(
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteLogistic(
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const AUTOCOMPLETE_LOGISTIC_ORIGIN = gql`
  query autocompleteLogisticOrigin(
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteLogisticOrigin(
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const AUTOCOMPLETE_COMPANY = gql`
  query autocompleteCompany(
    $clientId: Int!
    $companyIds: [Int!]!
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteCompany(
      clientId: $clientId
      companyIds: $companyIds
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const AUTOCOMPLETE_DEPOSIT = gql`
  query autocompleteDeposit(
    $autocompleteFilter: AutocompleteFilter!
  ) {
    autocompleteDeposit(
      autocompleteFilter: $autocompleteFilter
    )
  }
`;

export const DELETE_INVOICES = gql`
  mutation deleteInvoices($invoiceIds: [Int!]!) {
    deleteInvoices(invoiceIds: $invoiceIds) {
      count
    }
  }
`;

export const DELETE_TAXES = gql`
  mutation deleteTaxes($taxIds: [Int!]!) {
    deleteTaxes(taxIds: $taxIds) {
      count
    }
  }
`;

export const DELETE_COMPANIES = gql`
  mutation deleteCompanies($companyIds: [Int!]!) {
    deleteCompanies(companyIds: $companyIds) {
      count
    }
  }
`;

export const DELETE_DEPOSITS = gql`
  mutation deleteDeposits($depositIds: [Int!]!) {
    deleteDeposits(depositIds: $depositIds) {
      count
    }
  }
`;

export const DELETE_LOGISTICS = gql`
  mutation deleteLogistics($logisticIds: [Int!]!) {
    deleteLogistics(logisticIds: $logisticIds) {
      count
    }
  }
`;

export const DELETE_LOGISTIC_ORIGINS = gql`
  mutation deleteLogisticOrigins($logisticOriginIds: [Int!]!) {
    deleteLogisticOrigins(logisticOriginIds: $logisticOriginIds) {
      count
    }
  }
`;

export const UPDATE_INVOICE = gql`
  mutation updateInvoice(
    $invoiceId: Int!
    $companyId: Int!
    $createInvoiceTaxesInput: [CreateInvoiceTaxInput!]!
    $updateInvoiceInput: UpdateInvoiceInput!
  ) {
    updateInvoice(
      invoiceId: $invoiceId
      companyId: $companyId
      createInvoiceTaxesInput: $createInvoiceTaxesInput
      updateInvoiceInput: $updateInvoiceInput
    ) {
      id
      product
      date
      crt
      invoiceNumber
      invoiceValue
      invoiceQuantity
      unitCostReal
      realValue
      status
      totalCost
      unitCostTotal
      unitSale
      unitProfit
      totalProfit
      labeled
      observation
      invoiceTaxes {
        id
        value
        tax {
          id
          value
          name
          description
          createdAt
          updatedAt
        }
      }
      company {
        id
        name
      }
      group {
        id
        number
        name
      }
      clientId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_TAX = gql`
  mutation updateTax($taxId: Int!, $updateTaxInput: UpdateTaxInput!) {
    updateTax(taxId: $taxId, updateTaxInput: $updateTaxInput) {
      id
      name
      value
      description
      clientId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_COMPANY = gql`
  mutation updateCompany(
    $companyId: Int!
    $updateCompanyInput: UpdateCompanyInput!
  ) {
    updateCompany(
      companyId: $companyId
      updateCompanyInput: $updateCompanyInput
    ) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_DEPOSIT = gql`
  mutation updateDeposit(
    $depositId: Int!
    $updateDepositInput: UpdateDepositInput!
  ) {
    updateDeposit(
      depositId: $depositId
      updateDepositInput: $updateDepositInput
    ) {
      id
      date
      reference
      value
      locked
      user {
        id
        email
        username
        name
      }
      company {
        id
        name
      }
      group {
        id
        number
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_LOGISTIC = gql`
  mutation updateLogistic(
    $logisticId: Int!
    $updateLogisticInput: UpdateLogisticInput!
  ) {
    updateLogistic(
      logisticId: $logisticId
      updateLogisticInput: $updateLogisticInput
    ) {
      id
      quantityVolume
      nrcInvoiceNumber
      clientInvoiceNumber
      crt
      clientName
      warehouseDispatchDate
      revenueDate
      customsDate
      storageDate
      clientDate
      releaseDate
      observation
      user {
        id
        email
        username
        name
      }
      company {
        id
        name
      }
      group {
        id
        number
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_LOGISTIC_ORIGIN = gql`
  mutation updateLogisticOrigin(
    $logisticOriginId: Int!
    $updateLogisticOriginInput: UpdateLogisticOriginInput!
  ) {
    updateLogisticOrigin(
      logisticOriginId: $logisticOriginId
      updateLogisticOriginInput: $updateLogisticOriginInput
    ) {
      id
      originInvoiceNumber
      quantityVolume
      releaseDate
      user {
        id
        email
        username
        name
      }
      company {
        id
        name
      }
      group {
        id
        number
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_MANY_DEPOSITS = gql`
  mutation updateManyDeposits(
    $depositIds: [Int!]!
    $updateDepositInput: UpdateDepositInput!
  ) {
    updateManyDeposits(
      depositIds: $depositIds
      updateDepositInput: $updateDepositInput
    ) {
      count
    }
  }
`;

export const UPDATE_LOCK_INVOICE = gql`
  mutation updateLockInvoice($invoiceIds: [Int!]!, $locked: Boolean!) {
    updateLockInvoice(invoiceIds: $invoiceIds, locked: $locked) {
      count
    }
  }
`;

export const FILTER_GROUP = gql`
  query filterGroup($clientIds: [Int!], $groupIds: [Int!]) {
    filterGroup(clientIds: $clientIds, groupIds: $groupIds) {
      id
      name
      number
    }
  }
`;
